import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {baseUrl} from "../../../../core/constants/base-url";
import {resources} from "../../../../core/models/resource/resources";

@Injectable({
  providedIn: 'root'
})
export class MarketingBlocksApiService {
  private http: HttpClient = inject(HttpClient);

  public initializeMarketingBlocks(productCardId: number): Observable<void> {
    const params = { productCardId: productCardId.toString() };

    return this.http.post<void>(`${baseUrl}/${resources['marketing-blocks'].path}/initialize`, {}, {
      params: params
    });
  }
}
